import { render } from "./Vms.vue?vue&type=template&id=17a5fc5a&scoped=true"
import script from "./Vms.vue?vue&type=script&lang=js"
export * from "./Vms.vue?vue&type=script&lang=js"

import "../assets/css/viver-style.css?vue&type=style&index=0&id=17a5fc5a&scoped=true&lang=css&external"
import "./Vms.vue?vue&type=style&index=1&id=17a5fc5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a5fc5a"]])

export default __exports__